import React from 'react';

const AllianceExploring = () => {
  return <h1>AllianceExploring Page</h1>;
};

export default AllianceExploring;
